import { AxiosPromise } from 'axios';
import {
  IGetItems,
  IFirstItem,
  IGetFirstItems,
  ISecondItem,
  IGetSecondItems,
  IThirdItem,
  IGetThirdItems,
  IEvaluationItemParams,
  IGetEvaluationItem,
  IEvaluationItemBody,
  IEvaluationItemCreate,
  IGetEvaluationItemTree,
} from '../models/evaluationItem.model';
import axios from 'axios';

const uri = '/mgmt/evaluation/item';

export const getItems = (): AxiosPromise<IGetItems> => {
  return axios.get(uri);
};

export const getFirstItems = (): AxiosPromise<IGetFirstItems> => {
  return axios.get(`${uri}/1st`);
};

export const createFirstItem = (data: IFirstItem): AxiosPromise => {
  return axios.post(`${uri}/1st`, data);
};

export const updateFirstItem = (
  itemCode: number,
  data: IFirstItem,
): AxiosPromise => {
  return axios.put(`${uri}/1st/${itemCode}`, data);
};

export const getSecondItems = (
  parentCode: number,
): AxiosPromise<IGetSecondItems> => {
  return axios.get(`${uri}/2nd/${parentCode}`);
};

export const createSecondItem = (
  parentCode: number,
  data: ISecondItem,
): AxiosPromise => {
  return axios.post(`${uri}/2nd/${parentCode}`, data);
};

export const updateSecondItem = (
  itemCode: number,
  data: ISecondItem,
): AxiosPromise => {
  return axios.put(`${uri}/2nd/${itemCode}`, data);
};

export const getThirdItems = (
  parentCode: number,
): AxiosPromise<IGetThirdItems> => {
  return axios.get(`${uri}/3rd/${parentCode}`);
};

export const createThirdItem = (
  parentCode: number,
  data: IThirdItem,
): AxiosPromise => {
  return axios.post(`${uri}/3rd/${parentCode}`, data);
};

export const updateThirdItem = (
  itemCode: number,
  data: IThirdItem,
): AxiosPromise => {
  return axios.put(`${uri}/3rd/${itemCode}`, data);
};

export const getEvaluationItem = (
  params?: IEvaluationItemParams,
): AxiosPromise<IGetEvaluationItem> => axios.get(`${uri}/todo`, { params });

export const postEvaluationItem = (body: IEvaluationItemCreate): AxiosPromise =>
  axios.post(uri, body);

export const putEvaluationItem = (
  evaluationItemCode: number | string,
  body: IEvaluationItemBody,
): AxiosPromise => axios.put(`${uri}/${evaluationItemCode}`, body);

export const getEvaluationItemTree = (learningTypeCode: string): AxiosPromise<IGetEvaluationItemTree> =>
  axios.get(`${uri}/tree/${learningTypeCode}`);